"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalStore = void 0;
var utils_1 = require("../utils");
/**
 * Representation of browser localStorage
 */
var LocalStore = /** @class */ (function () {
    function LocalStore() {
    }
    // public readonly options: Required<LocalStoreOptions>
    /**
     * Try setting a browser localStorage value to test if localStorage is available
     * @returns
     */
    LocalStore.available = function () {
        var test = 's10-test';
        try {
            localStorage.setItem(test, test);
            localStorage.removeItem(test);
            return true;
        }
        catch (e) {
            return false;
        }
    };
    Object.defineProperty(LocalStore, "defaults", {
        /**
         * CookieStore default Option values
         */
        get: function () {
            if ((0, utils_1.isServer)()) {
                return {
                    fallbackEnabled: false,
                };
            }
            return {
                fallbackEnabled: true,
            };
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Get from browser localStorage
     * @param key Key to get
     * @returns
     */
    LocalStore.prototype.get = function (key) {
        var val = localStorage.getItem(key);
        if (val) {
            try {
                return JSON.parse(val);
            }
            catch (e) {
                return JSON.parse(JSON.stringify(val));
            }
        }
        return undefined;
    };
    /**
     * Set value to browser localStorage
     * @param key Key to set
     * @param value Value to store
     * @returns
     */
    LocalStore.prototype.set = function (key, value) {
        try {
            localStorage.setItem(key, JSON.stringify(value));
        }
        catch (_a) {
            console.warn("Unable to set ".concat(key, " in localStorage, storage may be full."));
        }
        return value;
    };
    /**
     * Remove item from browser localStorage
     * @param key Key to remove
     * @returns
     */
    LocalStore.prototype.remove = function (key) {
        return localStorage.removeItem(key);
    };
    return LocalStore;
}());
exports.LocalStore = LocalStore;
//# sourceMappingURL=local.store.js.map